<template>
  <div class="middle-page-url-block__root">
    <div class="icon"></div>
    <div class="label">违规链接，禁止访问</div>
  </div>
</template>

<style lang="scss" scoped>
.middle-page-url-block {
  &__root {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      display: inline-block;
      background-image: url('@/assets/svg/white/icon-no-permission.svg');
      width: 100px;
      height: 100px;
    }

    .label {
      margin-top: 12px;
      height: 22px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: var(--lowcode-text-02);
      line-height: 22px;
    }
  }
}
</style>
